import React, { useContext } from 'react';
import './Navbar.css';
import { SidebarData } from './SidebarData';
import { IconContext } from 'react-icons';
import SubMenu from './SubMenu';
import * as FaIcons from 'react-icons/fa';
import { UserContext } from '../../App';

function Navbar({ sidebar }) {
  const user = useContext(UserContext);
  const updatedSidebarData = [...SidebarData];

  if (user?.firstRole || user?.roles?.includes('finalizada-formacion')) {
    updatedSidebarData.push({
      title: 'Empresas',
      path: '/chat',
      icon: <FaIcons.FaBriefcase />,
      cName: 'nav-text',
    });
  }

  updatedSidebarData.push({
    title: 'Mentorías',
    path: '/calendario',
    icon: <FaIcons.FaCalendarAlt />,
    cName: 'nav-text',
  });

  if (user?.firstRole || user?.roles?.includes('fase-practica')) {
    updatedSidebarData.push({
      title: 'Prácticas',
      path: '/practicas',
      icon: <FaIcons.FaHandshake />,
      cName: 'nav-text',
    });
  }

  if (user?.firstRole) {
    updatedSidebarData.push({
      title: 'Admin',
      icon: <FaIcons.FaCogs />,
      cName: 'nav-text',
      subNav: [
        {
          title: 'Administrar Módulos',
          path: '/Admin/AdminModulos',
          icon: <FaIcons.FaEdit />,
        },
        {
          title: 'Control de Usuarios',
          path: '/Admin/AdminUsuarios',
          icon: <FaIcons.FaUsers />,
        },
      ],
    });
  }
  return (
    <IconContext.Provider value={{ color: '#fff' }}>
      <nav className={sidebar ? 'nav-menu active' : 'nav-menu'}>
        <ul className='nav-menu-items'>
          {updatedSidebarData.map((item, index) => (
            <SubMenu item={item} key={index} />
          ))}
        </ul>
      </nav>
    </IconContext.Provider>
  );
}

export default Navbar;
